import script from "./ServicesFromPriceBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicesFromPriceBlock.vue?vue&type=script&setup=true&lang=js"

import "./ServicesFromPriceBlock.vue?vue&type=style&index=0&id=16d7531c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16d7531c"]])

export default __exports__